"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendCKBFromRSALock = exports.generateSecp256k1Tx = exports.sendCKBFromEthK1Lock = exports.sendCKBFromP256Lock = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const constants_1 = require("../constants");
const rsa2048_1 = require("../signature/rsa2048");
const secp256k1_1 = require("../signature/secp256k1");
const secp256r1_1 = require("../signature/secp256r1");
const utils_1 = require("../utils");
const sendCKBFromP256Lock = (collector, mainPrivateKey, from, to, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const isMainnet = from.startsWith('ckb');
    const fromLock = (0, ckb_sdk_utils_1.addressToScript)(from);
    const cells = yield collector.getCells(fromLock);
    if (cells == undefined || cells.length == 0) {
        throw new Error('The from address has no live cells');
    }
    const { inputs, capacity: inputCapacity } = collector.collectInputs(cells, amount, constants_1.FEE);
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(to);
    let outputs = [];
    if (inputCapacity + constants_1.FEE === amount) {
        outputs.push({
            capacity: `0x${inputCapacity.toString(16)}`,
            lock: toLock,
        });
    }
    else {
        outputs.push({
            capacity: `0x${amount.toString(16)}`,
            lock: toLock,
        });
        const changeCapacity = inputCapacity - constants_1.FEE - amount;
        outputs.push({
            capacity: `0x${changeCapacity.toString(16)}`,
            lock: fromLock,
        });
    }
    const cellDeps = [(0, constants_1.getJoyIDCellDep)(isMainnet)];
    const rawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData: outputs.map(_o => '0x'),
        witnesses: [],
    };
    rawTx.witnesses = rawTx.inputs.map((_, i) => (i > 0 ? '0x' : { lock: '', inputType: '', outputType: '' }));
    const key = (0, utils_1.keyFromPrivate)(mainPrivateKey, utils_1.SigAlg.Secp256r1);
    const signedTx = (0, secp256r1_1.signSecp256r1Tx)(key, rawTx);
    console.info(JSON.stringify(signedTx));
    let txHash = yield collector.getCkb().rpc.sendTransaction(signedTx, 'passthrough');
    console.info(`sendCKBFromP256Lock tx has been sent with tx hash ${txHash}`);
    return txHash;
});
exports.sendCKBFromP256Lock = sendCKBFromP256Lock;
const sendCKBFromEthK1Lock = (collector, mainPrivateKey, from, to, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const isMainnet = from.startsWith('ckb');
    const fromLock = (0, ckb_sdk_utils_1.addressToScript)(from);
    const cells = yield collector.getCells(fromLock);
    if (cells == undefined || cells.length == 0) {
        throw new Error('The from address has no live cells');
    }
    const { inputs, capacity: inputCapacity } = collector.collectInputs(cells, amount, constants_1.FEE);
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(to);
    let outputs = [];
    if (inputCapacity + constants_1.FEE === amount) {
        outputs.push({
            capacity: `0x${inputCapacity.toString(16)}`,
            lock: toLock,
        });
    }
    else {
        outputs.push({
            capacity: `0x${amount.toString(16)}`,
            lock: toLock,
        });
        const changeCapacity = inputCapacity - constants_1.FEE - amount;
        outputs.push({
            capacity: `0x${changeCapacity.toString(16)}`,
            lock: fromLock,
        });
    }
    const cellDeps = [(0, constants_1.getJoyIDCellDep)(isMainnet)];
    const rawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData: outputs.map(_o => '0x'),
        witnesses: [],
    };
    rawTx.witnesses = rawTx.inputs.map((_, i) => (i > 0 ? '0x' : { lock: '', inputType: '', outputType: '' }));
    const key = (0, utils_1.keyFromPrivate)(mainPrivateKey, utils_1.SigAlg.Secp256k1);
    const signedTx = (0, secp256k1_1.signSecp256k1Tx)(key, rawTx);
    console.info(JSON.stringify(signedTx));
    let txHash = yield collector.getCkb().rpc.sendTransaction(signedTx, 'passthrough');
    console.info(`sendCKBFromEthK1Lock tx has been sent with tx hash ${txHash}`);
    return txHash;
});
exports.sendCKBFromEthK1Lock = sendCKBFromEthK1Lock;
const generateSecp256k1Tx = (collector, from, to, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const isMainnet = from.startsWith('ckb');
    const fromLock = (0, ckb_sdk_utils_1.addressToScript)(from);
    const cells = yield collector.getCells(fromLock);
    if (cells == undefined || cells.length == 0) {
        throw new Error('The from address has no live cells');
    }
    const { inputs, capacity: inputCapacity } = collector.collectInputs(cells, amount, constants_1.FEE);
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(to);
    let outputs = [
        {
            capacity: `0x${amount.toString(16)}`,
            lock: toLock,
        },
    ];
    const changeCapacity = inputCapacity - constants_1.FEE - amount;
    outputs.push({
        capacity: `0x${changeCapacity.toString(16)}`,
        lock: fromLock,
    });
    const cellDeps = [(0, constants_1.getJoyIDCellDep)(isMainnet)];
    const rawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData: ['0x', '0x'],
        witnesses: [],
    };
    rawTx.witnesses = rawTx.inputs.map((_, i) => (i > 0 ? '0x' : { lock: '', inputType: '', outputType: '' }));
    const sighashAll = (0, secp256k1_1.generateSighashAll)(rawTx);
    return [rawTx, sighashAll];
});
exports.generateSecp256k1Tx = generateSecp256k1Tx;
const sendCKBFromRSALock = (collector, mainPrivateKey, from, to, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const isMainnet = from.startsWith('ckb');
    const fromLock = (0, ckb_sdk_utils_1.addressToScript)(from);
    const cells = yield collector.getCells(fromLock);
    if (cells == undefined || cells.length == 0) {
        throw new Error('The from address has no live cells');
    }
    const { inputs, capacity: inputCapacity } = collector.collectInputs(cells, amount, constants_1.FEE);
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(to);
    let outputs = [];
    if (inputCapacity + constants_1.FEE === amount) {
        outputs.push({
            capacity: `0x${inputCapacity.toString(16)}`,
            lock: toLock,
        });
    }
    else {
        outputs.push({
            capacity: `0x${amount.toString(16)}`,
            lock: toLock,
        });
        const changeCapacity = inputCapacity - constants_1.FEE - amount;
        outputs.push({
            capacity: `0x${changeCapacity.toString(16)}`,
            lock: fromLock,
        });
    }
    const cellDeps = [(0, constants_1.getJoyIDCellDep)(isMainnet)];
    const rawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData: outputs.map(_o => '0x'),
        witnesses: [],
    };
    rawTx.witnesses = rawTx.inputs.map((_, i) => (i > 0 ? '0x' : { lock: '', inputType: '', outputType: '' }));
    const key = (0, utils_1.pemToKey)(mainPrivateKey);
    const signedTx = (0, rsa2048_1.signRSATx)(key, rawTx);
    console.info(JSON.stringify(signedTx));
    let txHash = yield collector.getCkb().rpc.sendTransaction(signedTx, 'passthrough');
    console.info(`sendCKBFromRSALock tx has been sent with tx hash ${txHash}`);
    return txHash;
});
exports.sendCKBFromRSALock = sendCKBFromRSALock;
